
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    ADD_OEM_GET_INTEGRATIONS_REQUEST,
    ADD_OEM_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { addOemGetIntegrationsResult, addOemResult } from 'Redux/actions';


function* getIntegrations() {
    try {

        const QUERY = `
        query searchIntegrations ($conditions: [IntegrationSearchInput], $sort: [IntegrationSortInput], $limit: Int, $offset: Int) {
            result: searchIntegrations (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    code
                    name
                    description
                }
                total
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [],
                sort: {
                    field: "name",
                    order: "ASC"
                },
                limit: 20,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(addOemGetIntegrationsResult(data?.result))
        } else {
            yield put(addOemGetIntegrationsResult({ error: true }))
        }

    } catch (exc) {
        yield put(addOemGetIntegrationsResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/accounts/.components/addOem/redux/saga",
            "getIntegrations",
        )
    }
}

function* addOem({ payload }) {
    try {
        let { companyIntegrationId, fleetId, oem, fanId } = payload
        let QUERY = `
            mutation addOEM($companyIntegrationId: Int!, $fleetId: Int!, $oem: String!, $fanId: String) {
                response: addOEM (companyIntegrationId: $companyIntegrationId, fleetId: $fleetId, oem: $oem, fanId: $fanId){
                    fleetId
                    name
                    fleetStatus
                    fanId
                    oems {
                        name
                        consentStatus
                    }
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                companyIntegrationId,
                fleetId,
                oem,
                fanId
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(addOemResult({ result: data?.response }))

    } catch (exc) {
        yield put(addOemResult({ error: exc }))
        ExceptionManager(
            exc,
            "Modules/accounts/.components/addOem/redux/saga",
            "addOem",
        )
    }
}

export const getAccounts = async (input = '') => {
    try {
        let QUERY = `
        query searchCompanies ($conditions: [CompanySearchInput], $sort: [CompanySortInput], $limit: Int, $offset: Int) {
            result: searchCompanies (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                    status
                }
            }
        }`
        return await clientQuery(QUERY, {
            conditions: {
                fields: [
                    "name"
                ],
                terms: [
                    input
                ],
                exact: false
            },
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);
    } catch (exc) {
        ExceptionManager(exc, 'Modules/activities/.components/tab/redux/saga', 'getAccounts');
    }
}

function* watchMethods() {
    yield takeEvery(ADD_OEM_GET_INTEGRATIONS_REQUEST, getIntegrations);
    yield takeEvery(ADD_OEM_REQUEST, addOem);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}